export default (a = {}) => (
  [
    a.postalCode ? a.postalCode : '',
    a.cityName ? a.cityName : '',
    a.streetName ? 'ул. ' + a.streetName : '',
    a.house ? 'д. ' + a.house : '',
    a.houseBlock ? 'корпус ' + a.houseBlock : '',
    a.building ? 'строение ' + a.building : '',
    a.entrance ? 'подъезд ' + a.entrance : '',
    a.apartment ? 'кв. ' + a.apartment : '',
    a.floor ? 'этаж ' + a.floor : '',
    a.metroStationName ? 'метро ' + a.metroStationName : '',
  ].filter(t => !!t).join(', ')
);
